import request, { ResponseData, PagerData } from '@/libs/request/request'
import { User } from 'src/api/user/User'
import { GenealogyApplyQuery } from 'src/api/genealogy/GenealogyApplyQuery'

// GenealogyApplyByEntrust
export type GenealogyApplyByEntrust = {

  // 地址}
  address?:string

  // ID
  id?:number

  // 是否同意申请，此字段作废
  isAgree?:number

  // 姓名}
  name?:string

  // 电话}
  phone?:string

  // 申请的类型：1.委托制作，2.创建族谱，3.加入族谱
  type?:number

  // 用户
  user?:User

  // 关联用户id}
  userId?:number

  // 创建时间
  createTime?:string

  // 城市名
  city?:string

  // 申请状态：1.申请中，2.驳回，3.已退出，4.已完成
  status?:number

  // 村庄名
  villageName?:string
}

export default class GenealogyApplyByEntrustService {
  /**
   * 获取委托制作族谱申请的分页数据
   * @param {GenealogyApplyQuery} query 族谱申请实体查询条件
   **/
  static getPagesOfGenealogyApplyByEntrust (query?:GenealogyApplyQuery):Promise<ResponseData<PagerData<GenealogyApplyByEntrust>>> {
    return request<ResponseData<PagerData<GenealogyApplyByEntrust>>>({
      method: 'POST',
      data: query,
      url: '/admin/GenealogyApply/GenealogyApply/genealogyApplyByEntrust'
    })
  }
}
